import { scope } from "@otto-ec/global-resources/debug";

export const logscope = scope("reptile.everglades");
